import * as types from './types';

const mutations = {
  // RESET
  [types.RESET](state) {
    state.employees = [];
    state.employeesAssignment = [];
    state.employeesReenter = [];
  },

  // FETCH_EMPLOYEES
  [types.FETCH_EMPLOYEES_PENDING](state) {
    state.fetchEmployeesPending = true;
  },
  [types.FETCH_EMPLOYEES_FULFILLED](state, { data }) {
    state.employees = data.data;
    state.fetchEmployeesPending = false;
  },
  [types.FETCH_EMPLOYEES_ERROR](state) {
    state.fetchEmployeesPending = false;
  },
  // STORE_EMPLOYEE
  [types.STORE_EMPLOYEE_PENDING](state) {
    state.storeEmployeePending = true;
  },
  [types.STORE_EMPLOYEE_FULFILLED](state) {
    state.storeEmployeePending = false;
  },
  [types.STORE_EMPLOYEE_ERROR](state) {
    state.storeEmployeePending = false;
  },
  // DELETE_EMPLOYEE
  [types.DELETE_EMPLOYEE_PENDING](state) {
    state.deleteEmployeePending = true;
  },
  [types.DELETE_EMPLOYEE_FULFILLED](state) {
    state.deleteEmployeePending = false;
  },
  [types.DELETE_EMPLOYEE_ERROR](state) {
    state.deleteEmployeePending = false;
  },

  // FETCH_EMPLOYEES_ASSIGNMENT
  [types.FETCH_EMPLOYEES_ASSIGNMENT_PENDING](state) {
    state.fetchEmployeesAssignmentPending = true;
  },
  [types.FETCH_EMPLOYEES_ASSIGNMENT_FULFILLED](state, { data }) {
    state.employeesAssignment = data.data;
    state.fetchEmployeesAssignmentPending = false;
  },
  [types.FETCH_EMPLOYEES_ASSIGNMENT_ERROR](state) {
    state.fetchEmployeesAssignmentPending = false;
  },
  // STORE_EMPLOYEE
  [types.STORE_EMPLOYEE_ASSIGNMENT_PENDING](state) {
    state.storeEmployeeAssignmentPending = true;
  },
  [types.STORE_EMPLOYEE_ASSIGNMENT_FULFILLED](state) {
    state.storeEmployeeAssignmentPending = false;
  },
  [types.STORE_EMPLOYEE_ASSIGNMENT_ERROR](state) {
    state.storeEmployeeAssignmentPending = false;
  },

  // FETCH_EMPLOYEES_REENTER
  [types.FETCH_EMPLOYEES_REENTER_PENDING](state) {
    state.fetchEmployeesReenterPending = true;
  },
  [types.FETCH_EMPLOYEES_REENTER_FULFILLED](state, { data }) {
    state.employeesReenter = data.data;
    state.fetchEmployeesReenterPending = false;
  },
  [types.FETCH_EMPLOYEES_REENTER_ERROR](state) {
    state.fetchEmployeesReenterPending = false;
  },
  // STORE_EMPLOYEE_REENTER
  [types.STORE_EMPLOYEE_REENTER_PENDING](state) {
    state.storeEmployeeReenterPending = true;
  },
  [types.STORE_EMPLOYEE_REENTER_FULFILLED](state) {
    state.storeEmployeeReenterPending = false;
  },
  [types.STORE_EMPLOYEE_REENTER_ERROR](state) {
    state.storeEmployeeReenterPending = false;
  },
};

export default mutations;
